<script>
import Vue from 'vue';

export default Vue.extend({});
</script>

<template>
    <div class="style-guide-container">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="page-header">Headings</h1>

                    <h1>Lorem ipsum dolor sit amet</h1>
                    <h2>Lorem ipsum dolor sit amet</h2>
                    <h3>Lorem ipsum dolor sit amet</h3>
                    <h4>Lorem ipsum dolor sit amet</h4>
                    <h5>Lorem ipsum dolor sit amet</h5>
                    <h6>Lorem ipsum dolor sit amet</h6>

                    <h1 class="page-header">Typography</h1>

                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius error ex laboriosam minus modi nobis, reiciendis rem unde! Ad esse iure minima ratione repellat voluptates. Eveniet facilis modi numquam soluta!</p>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias commodi facere facilis impedit magnam perspiciatis placeat recusandae, ut veritatis vitae voluptatem voluptates. Ab ad amet animi aperiam asperiores atque aut, cupiditate debitis dolorum ducimus eligendi ex exercitationem harum itaque labore magni maiores, modi molestiae nulla <a href="#">read more</a> provident qui quibusdam quos repellat repellendus sequi suscipit ut. Animi eius et reiciendis sequi ut. Amet architecto cupiditate dicta dignissimos ducimus omnis quidem quo repellat sed, voluptas. Et laborum nesciunt perferendis.</p>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid, aut doloribus! A ab aperiam architecto assumenda atque beatae blanditiis consectetur cumque deserunt doloribus et inventore iure labore laborum magnam magni, maiores molestiae molestias mollitia necessitatibus nesciunt nobis nostrum odio, odit omnis possimus praesentium quae qui, quidem quod similique sunt suscipit tempora. Accusantium blanditiis consectetur culpa fuga quod reiciendis, sequi sint.</p>

                    <h1 class="page-header">Forms</h1>

                    <div class="row">
                        <div class="col-md-4">
                            <p><input class="input" type="text" value="Lorem ipsum"></p>
                            <p><input class="input" type="number" value="300"></p>
                            <p>
                                <select class="input">
                                    <option value="3">Lorem ipsum 1</option>
                                    <option value="3">Lorem ipsum 2</option>
                                    <option value="3">Lorem ipsum 3</option>
                                </select>
                            </p>
                        </div>
                    </div>

                    <h1 class="page-header">Buttons</h1>

                    <button class="button__primary button__primary--lg">Read more</button>
                    <button class="button__info button__info--lg">Read more</button>
                    <button class="button__warning button__warning--lg">Read more</button>
                    <button class="button__danger button__danger--lg">Read more</button>
                    <button class="button__success button__success--lg">Read more</button>

                    <br>
                    <br>

                    <button class="button__primary">Read more</button>
                    <button class="button__info">Read more</button>
                    <button class="button__warning">Read more</button>
                    <button class="button__danger">Read more</button>
                    <button class="button__success">Read more</button>

                    <br>
                    <br>

                    <button class="button__primary button__primary--sm">Read more</button>
                    <button class="button__info button__info--sm">Read more</button>
                    <button class="button__warning button__warning--sm">Read more</button>
                    <button class="button__danger button__danger--sm">Read more</button>
                    <button class="button__success button__success--sm">Read more</button>

                    <br>
                    <br>

                    <button class="button__primary button__primary--xs">Read more</button>
                    <button class="button__info button__info--xs">Read more</button>
                    <button class="button__warning button__warning--xs">Read more</button>
                    <button class="button__danger button__danger--xs">Read more</button>
                    <button class="button__success button__success--xs">Read more</button>

                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>

                    <div class="alert alert--danger">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum, numquam.
                    </div>

                    <div class="alert alert--warning">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum, numquam.
                    </div>

                    <div class="alert alert--success">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum, numquam.
                    </div>

                    <div class="alert alert--info">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum, numquam.
                    </div>

                    <div class="alert alert--primary">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum, numquam.
                    </div>

                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>

                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/StyleGuideContainer/StyleGuideContainer.vue